module.exports = __webpack_public_path__ + "d3a046e0d14b6c8e4be88f40402e37c3.png";